type Props = {
  value: number
  dark?: boolean
  className?: string
}

export const Price = ({ value, className, dark }: Props) => {
  return (
    <span
      className={className}
      style={{ display: 'flex', alignItems: 'center' }}
    >
      <svg
        style={{
          height: '1em',
          marginRight: '5rem',
          marginTop: '-0.25em',
          verticalAlign: 'middle',
        }}
        viewBox="0 0 12 14"
        fill="none"
      >
        <defs>
        <linearGradient
          id="price-grad"
          gradientUnits="objectBoundingBox"
          x1="0.85"
          y1="0"
          x2="0.15"
          y2="1"
        >
          <stop offset="-12.88%" stopColor="#000000"/>
          <stop offset="105.35%" stopColor="#7F7F7F"/>
        </linearGradient>
        </defs>
        <path
          d="M6.37 1.74C6.22 1.42 5.78 1.42 5.63 1.74L4.22 4.63C4.16 4.75 4.04 4.84 3.91 4.86L0.85 5.37C0.52 5.43 0.38 5.86 0.62 6.11L2.63 8.22C2.74 8.34 2.91 8.38 3.05 8.33C3.67 8.12 5.25 7.59 5.54 7.49C5.76 7.41 5.92 7.71 5.74 7.86L2.91 10.31C2.76 10.45 2.65 10.64 2.62 10.85L2.45 11.99C2.39 12.35 2.74 12.61 3.05 12.45L5.81 10.98C5.93 10.92 6.07 10.92 6.19 10.98L8.95 12.45C9.26 12.61 9.61 12.35 9.55 11.99L9.07 8.79C9.05 8.65 9.09 8.51 9.19 8.41L11.38 6.11C11.62 5.86 11.48 5.43 11.15 5.37L8.09 4.86C7.96 4.84 7.84 4.75 7.78 4.63L6.37 1.74Z"
          fill={dark ? "url(#price-grad)" : "white"}
        />
      </svg>
      <span>{value}</span>
    </span>
  )
}
